// Slim yellow accent used to signal "chapter starts here" above H1s on every
// route. Matches the yellow header top strip + footer copyright bar bookends.
// Small, decorative, aria-hidden.
export const PageAccent = ({ className = "" }) => (
  <span
    aria-hidden="true"
    data-testid="page-accent"
    className={`block h-1 w-14 rounded-full bg-yellow ${className}`}
  />
);
